var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M12,4.447a7.5,7.5,0,1,1-7.5,7.5","key":1}),React.createElement("path",{"className":"a","d":"M22.942,14.523a11.42,11.42,0,0,1-1.087,2.848","key":2}),React.createElement("path",{"className":"a","d":"M19.814,20.031a12.161,12.161,0,0,1-2.455,1.81","key":3}),React.createElement("path",{"className":"a","d":"M12.993.747a11.137,11.137,0,0,1,2.971.682","key":4}),React.createElement("path",{"className":"a","d":"M18.888,3.065a10.807,10.807,0,0,1,2.131,2.178","key":5}),React.createElement("path",{"className":"a","d":"M22.6,8.2a10.5,10.5,0,0,1,.614,2.984","key":6}),React.createElement("path",{"className":"a","d":"M14.25,22.972A11.252,11.252,0,0,1,9.75.922","key":7})]);
}

Spinner.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Spinner;

Spinner.default = Spinner;



//////////////////
// WEBPACK FOOTER
// ./src/components/spinner/spinner.svg
// module id = 955
// module chunks = 0